module.exports = __webpack_public_path__ + "thumb.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].png!./client/assets/thumb.png
// module id = 9
// module chunks = 0